import { Component, ElementRef, Input, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';

import timezones from '../../timezones';

const ZONES_EUROPE_FIRST = [
  ...timezones.filter(zone => zone.indexOf('Europe/') === 0),
  ...timezones.filter(zone => zone.indexOf('Europe/') !== 0)
];

@Component({
  selector: 'app-timezone-picker',
  templateUrl: './timezone-picker.component.html',
  styleUrls: ['./timezone-picker.component.scss']
})
export class TimezonePickerComponent {

  @Input() parentFormControl: FormControl;
  @Input() inputId: string;

  @ViewChild('field') private field: ElementRef<HTMLInputElement>;
  @ViewChildren('zoneOption') private zoneOptions: QueryList<ElementRef<HTMLButtonElement>>;

  public visibleZones: string[] = ZONES_EUROPE_FIRST;

  showAllZones(picker: NgbDropdown) {
    if (picker.isOpen()) {
      return;
    }
    this.visibleZones = ZONES_EUROPE_FIRST;
    picker.open();
  }

  filterZones(term: string, picker: NgbDropdown) {
    const wanted = (term || '').trim().toLowerCase();
    this.visibleZones = wanted
      ? ZONES_EUROPE_FIRST.filter(zone => zone.toLowerCase().indexOf(wanted) !== -1)
      : ZONES_EUROPE_FIRST;
    picker.open();
  }

  enterZones(picker: NgbDropdown) {
    if (picker.isOpen()) {
      this.focusZone(0);
      return;
    }
    this.showAllZones(picker);
  }

  moveBetweenZones(from: number, step: number) {
    this.focusZone(from + step);
  }

  choose(zone: string, picker: NgbDropdown) {
    this.parentFormControl.setValue(zone);
    this.parentFormControl.markAsDirty();
    picker.close();
    this.field.nativeElement.focus();
  }

  private focusZone(index: number) {
    const option = this.zoneOptions.toArray()[index];
    (option ? option.nativeElement : this.field.nativeElement).focus();
  }
}
